/* src/app/fuel/pages/fuel-new/fuel-new.component.scss */
/*# sourceMappingURL=fuel-new.component.css.map */
